import { render, staticRenderFns } from "./MdtpProviderStatusList.vue?vue&type=template&id=56eb6552"
import script from "./MdtpProviderStatusList.vue?vue&type=script&lang=js"
export * from "./MdtpProviderStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports